<div class="position-relative" style="width: fit-content">
  <canvas [width]="width ?? 300" [height]="height ?? 130" style="border: 1px dashed var(--color-ink)" #signatureCanvas></canvas>
  <div class="text-center">{{ signatureTitle ?? 'Your signature' }}</div>
  @if (signatureSubtitle) {
    <div class="text-center text-muted" style="font-size: var(--fs-xs)">{{ signatureSubtitle }}</div>
  }
  @if (!signatureIsEmpty) {
    <a class="d-block position-absolute" style="top: 1rem; right: 1rem; font-size: var(--fs-2xl)" (click)="onClear()">
      <i class="fa-solid fa-arrow-rotate-left"></i>
    </a>
  }
</div>
